import { defineComponent } from '~/utils/alpine_types'

declare global {
  interface Window {
    Tawk_API: {
      onLoad: () => void
      setAttributes: (
        data: { name: string; email: string; hash: string },
        callback: (error: string | null) => void,
      ) => void
    }
  }
}

export const tawkTo = defineComponent(() => ({
  async init() {
    // Tawk.to chat widget code
    window.Tawk_API ||= {}
    const Tawk_LoadStart = new Date()

    // Send user data to the chat API if logged in
    window.Tawk_API.onLoad = async () => {
      const path = window.location.pathname
      if (!path.match(/student|teacher/)) return

      const course_id = path.match('video_lessons') ? path.split('video_lessons/')[1] : null
      const params = course_id ? new URLSearchParams({ course_id }) : new URLSearchParams()

      try {
        const res = await fetch(`/chat/get_user_data?${params.toString()}`)
        const data = await res.json()

        window.Tawk_API.setAttributes(data, (error) => {
          if (error) throw new Error(error)
        })
      } catch (error) {
        console.error(error)
      }
    }
  },
}))
